import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelStrategyCarouselComponent } from './model-strategy-carousel.component';
import { ModelStrategyCardComponent } from '../model-strategy-card/model-strategy-card.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModelStrategySwiperComponent } from '../model-strategy-swiper/model-strategy-swiper.component';

@NgModule({
  declarations: [
    ModelStrategyCarouselComponent,
    ModelStrategyCardComponent,
    ModelStrategySwiperComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    SwiperModule,
    AngularSvgIconModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    ModelStrategyCarouselComponent,
  ]
})
export class ModelStrategyCarouselModule { }
